// Copyright (c) 2020 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";

import "./LoadingAnimation.scss";

class LoadingAnimationComponent extends React.Component {
  public render() {
    // this component renders the loading animation used in the site animation while
    // connecting to the site. The loading screen in index.html is shown while the
    // frontend is loading, so this component provides a loading state for the
    // connection flow as well.
    return (
      <div id="loading">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <div style={{ alignSelf: "center" }}>
            <svg
              style={{ display: "block" }}
              width="200"
              height="200"
              viewBox="18 18 200 200"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="Frame 79">
                <circle id="EllipseOuter" opacity="0.05" cx="118" cy="118" r="91" fill="#DC3545" />
                <circle id="EllipseMiddle" opacity="0.05" cx="118" cy="118" r="59" fill="#DC3545" />
                <circle id="EllipseInner" opacity="0.05" cx="118" cy="118" r="45" fill="#DC3545" />
                <g id="Group 11">
                  <rect
                    id="Rectangle 1"
                    x="109.239"
                    y="89"
                    width="6.0239"
                    height="53.6949"
                    rx="3.01195"
                    fill="#DC3545"
                  />
                  <g id="Group 10">
                    <path
                      id="Rectangle 4"
                      d="M122.492 111.839C122.492 110.009 123.975 108.525 125.805 108.525C127.635 108.525 129.118 110.009 129.118 111.839V130.839C129.118 132.669 127.635 134.153 125.805 134.153C123.975 134.153 122.492 132.669 122.492 130.839V111.839Z"
                      fill="#DC3545"
                    />
                    <path
                      id="Rectangle 3"
                      d="M122.492 100.856C122.492 99.0257 123.975 97.5424 125.805 97.5424C127.635 97.5424 129.118 99.0257 129.118 100.856V100.941C129.118 102.771 127.635 104.254 125.805 104.254C123.975 104.254 122.492 102.771 122.492 100.941V100.856Z"
                      fill="#DC3545"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
    );
  }
}

export default LoadingAnimationComponent;
